export default __webpack_public_path__ + "static/media/icon.bb23ad55.png";